export const CountryCallingCodes =
  [
    {
      description: "Afganistán (+93)",
      code: "93"
    },
    {
      description: "Albania (+355)",
      code: "355"
    },
    {
      description: "Algeria (+213)",
      code: "213"
    },
    {
      description: "Samoa Americana (+1-684)",
      code: "1-684"
    },
    {
      description: "Andorra (+376)",
      code: "376"
    },
    {
      description: "Angola (+244)",
      code: "244"
    },
    {
      description: "Anguilla (+1-264)",
      code: "1-264"
    },
    {
      description: "Antártida (+672)",
      code: "672"
    },
    {
      description: "Antigua y Barbuda (+1-268)",
      code: "1-268"
    },
    {
      description: "Argentina (+54)",
      code: "54"
    },
    {
      description: "Armenia (+374)",
      code: "374"
    },
    {
      description: "Aruba (+297)",
      code: "297"
    },
    {
      description: "Australia (+61)",
      code: "61"
    },
    {
      description: "Austria (+43)",
      code: "43"
    },
    {
      description: "Azerbaiyán (+994)",
      code: "994"
    },
    {
      description: "Bahamas (+1-242)",
      code: "1-242"
    },
    {
      description: "Bahrain (+973)",
      code: "973"
    },
    {
      description: "Bangladesh (+880)",
      code: "880"
    },
    {
      description: "Barbados (+1-246)",
      code: "1-246"
    },
    {
      description: "Bielorrusia (+375)",
      code: "375"
    },
    {
      description: "Bélgica (+32)",
      code: "32"
    },
    {
      description: "Belice (+501)",
      code: "501"
    },
    {
      description: "Benin (+229)",
      code: "229"
    },
    {
      description: "Bermudas (+1-441)",
      code: "1-441"
    },
    {
      description: "Bután (+975)",
      code: "975"
    },
    {
      description: "Bolivia (+591)",
      code: "591"
    },
    {
      description: "Bosnia y Herzegovina (+387)",
      code: "387"
    },
    {
      description: "Botsuana (+267)",
      code: "267"
    },
    {
      description: "Brasil (+55)",
      code: "55"
    },
    {
      description: "Territorio Británico del Océano Índico (+246)",
      code: "246"
    },
    {
      description: "Islas Vírgenes Británicas (+1-284)",
      code: "1-284"
    },
    {
      description: "Brunei (+673)",
      code: "673"
    },
    {
      description: "Bulgaria (+359)",
      code: "359"
    },
    {
      description: "Burkina Faso (+226)",
      code: "226"
    },
    {
      description: "Burundi (+257)",
      code: "257"
    },
    {
      description: "Camboya (+855)",
      code: "855"
    },
    {
      description: "Camerún (+237)",
      code: "237"
    },
    {
      description: "Canada (+1)",
      code: "1"
    },
    {
      description: "Cabo Verde (+238)",
      code: "238"
    },
    {
      description: "Islas Caimán (+1-345)",
      code: "1-345"
    },
    {
      description: "República Centroafricana (+236)",
      code: "236"
    },
    {
      description: "Chad (+235)",
      code: "235"
    },
    {
      description: "Chile (+56)",
      code: "56"
    },
    {
      description: "China (+86)",
      code: "86"
    },
    {
      description: "Isla de Navidad (+61)",
      code: "61"
    },
    {
      description: "Islas Cocos (+61)",
      code: "61"
    },
    {
      description: "Colombia (+57)",
      code: "57"
    },
    {
      description: "Comoras (+269)",
      code: "269"
    },
    {
      description: "Islas Cook (+682)",
      code: "682"
    },
    {
      description: "Costa Rica (+506)",
      code: "506"
    },
    {
      description: "Croacia (+385)",
      code: "385"
    },
    {
      description: "Cuba (+53)",
      code: "53"
    },
    {
      description: "Curacao (+599)",
      code: "599"
    },
    {
      description: "Chipre (+357)",
      code: "357"
    },
    {
      description: "República Checa (+420)",
      code: "420"
    },
    {
      description: "República Democrática del Congo (+243)",
      code: "243"
    },
    {
      description: "Dinamarca (+45)",
      code: "45"
    },
    {
      description: "Djibouti (+253)",
      code: "253"
    },
    {
      description: "Dominica (+1-767)",
      code: "1-767"
    },
    {
      description: "República Dominicana (+1-809, 1-829, 1-849)",
      code: "1-809, 1-829, 1-849"
    },
    {
      description: "Timor Oriental (+670)",
      code: "670"
    },
    {
      description: "Ecuador (+593)",
      code: "593"
    },
    {
      description: "Egipto (+20)",
      code: "20"
    },
    {
      description: "El Salvador (+503)",
      code: "503"
    },
    {
      description: "Guinea Ecuatorial (+240)",
      code: "240"
    },
    {
      description: "Eritrea (+291)",
      code: "291"
    },
    {
      description: "Estonia (+372)",
      code: "372"
    },
    {
      description: "Etiopía (+251)",
      code: "251"
    },
    {
      description: "Islas Malvinas (+500)",
      code: "500"
    },
    {
      description: "Islas Faroe (+298)",
      code: "298"
    },
    {
      description: "Fiji (+679)",
      code: "679"
    },
    {
      description: "Finlandia (+358)",
      code: "358"
    },
    {
      description: "Francia (+33)",
      code: "33"
    },
    {
      description: "Polinesia Francesa (+689)",
      code: "689"
    },
    {
      description: "Gabón (+241)",
      code: "241"
    },
    {
      description: "Gambia (+220)",
      code: "220"
    },
    {
      description: "Georgia (+995)",
      code: "995"
    },
    {
      description: "Alemania (+49)",
      code: "49"
    },
    {
      description: "Ghana (+233)",
      code: "233"
    },
    {
      description: "Gibraltar (+350)",
      code: "350"
    },
    {
      description: "Grecia (+30)",
      code: "30"
    },
    {
      description: "Groelandia (+299)",
      code: "299"
    },
    {
      description: "Granada (+1-473)",
      code: "1-473"
    },
    {
      description: "Guam (+1-671)",
      code: "1-671"
    },
    {
      description: "Guatemala (+502)",
      code: "502"
    },
    {
      description: "Guernsey (+44-1481)",
      code: "44-1481"
    },
    {
      description: "Guinea (+224)",
      code: "224"
    },
    {
      description: "Guinea-Bisáu (+245)",
      code: "245"
    },
    {
      description: "Guyana (+592)",
      code: "592"
    },
    {
      description: "Haití (+509)",
      code: "509"
    },
    {
      description: "Honduras (+504)",
      code: "504"
    },
    {
      description: "Hong Kong (+852)",
      code: "852"
    },
    {
      description: "Hungría (+36)",
      code: "36"
    },
    {
      description: "Islandia (+354)",
      code: "354"
    },
    {
      description: "India (+91)",
      code: "91"
    },
    {
      description: "Indonesia (+62)",
      code: "62"
    },
    {
      description: "Iran (+98)",
      code: "98"
    },
    {
      description: "Iraq (+964)",
      code: "964"
    },
    {
      description: "Irlanda (+353)",
      code: "353"
    },
    {
      description: "Isla de Man (+44-1624)",
      code: "44-1624"
    },
    {
      description: "Israel (+972)",
      code: "972"
    },
    {
      description: "Italia (+39)",
      code: "39"
    },
    {
      description: "Costa de Marfil (+225)",
      code: "225"
    },
    {
      description: "Jamaica (+1-876)",
      code: "1-876"
    },
    {
      description: "Japón (+81)",
      code: "81"
    },
    {
      description: "Jersey (+44-1534)",
      code: "44-1534"
    },
    {
      description: "Jordania (+962)",
      code: "962"
    },
    {
      description: "Kazajstán (+7)",
      code: "7"
    },
    {
      description: "Kenia (+254)",
      code: "254"
    },
    {
      description: "Kiribati (+686)",
      code: "686"
    },
    {
      description: "Kosovo (+383)",
      code: "383"
    },
    {
      description: "Kuwait (+965)",
      code: "965"
    },
    {
      description: "Kirguistán (+996)",
      code: "996"
    },
    {
      description: "Laos (+856)",
      code: "856"
    },
    {
      description: "Letonia (+371)",
      code: "371"
    },
    {
      description: "Líbano (+961)",
      code: "961"
    },
    {
      description: "Lesoto (+266)",
      code: "266"
    },
    {
      description: "Liberia (+231)",
      code: "231"
    },
    {
      description: "Libia (+218)",
      code: "218"
    },
    {
      description: "Liechtenstein (+423)",
      code: "423"
    },
    {
      description: "Lituania (+370)",
      code: "370"
    },
    {
      description: "Luxemburgo (+352)",
      code: "352"
    },
    {
      description: "Macao (+853)",
      code: "853"
    },
    {
      description: "Macedonia (+389)",
      code: "389"
    },
    {
      description: "Madagascar (+261)",
      code: "261"
    },
    {
      description: "Malawi (+265)",
      code: "265"
    },
    {
      description: "Malasia (+60)",
      code: "60"
    },
    {
      description: "Maldivas (+960)",
      code: "960"
    },
    {
      description: "Mali (+223)",
      code: "223"
    },
    {
      description: "Malta (+356)",
      code: "356"
    },
    {
      description: "Islas Marshall (+692)",
      code: "692"
    },
    {
      description: "Mauritania (+222)",
      code: "222"
    },
    {
      description: "Mauricio (+230)",
      code: "230"
    },
    {
      description: "Mayotte (+262)",
      code: "262"
    },
    {
      description: "México (+52)",
      code: "52"
    },
    {
      description: "Micronesia (+691)",
      code: "691"
    },
    {
      description: "Maldovia (+373)",
      code: "373"
    },
    {
      description: "Mónaco (+377)",
      code: "377"
    },
    {
      description: "Mongolia (+976)",
      code: "976"
    },
    {
      description: "Montenegro (+382)",
      code: "382"
    },
    {
      description: "Montserrat (+1-664)",
      code: "1-664"
    },
    {
      description: "Marruecos (+212)",
      code: "212"
    },
    {
      description: "Mozambique (+258)",
      code: "258"
    },
    {
      description: "Myanmar (+95)",
      code: "95"
    },
    {
      description: "Namibia (+264)",
      code: "264"
    },
    {
      description: "Nauru (+674)",
      code: "674"
    },
    {
      description: "Nepal (+977)",
      code: "977"
    },
    {
      description: "Países Bajos (+31)",
      code: "31"
    },
    {
      description: "Antillas Holandesas (+599)",
      code: "599"
    },
    {
      description: "Nueva Calendonia (+687)",
      code: "687"
    },
    {
      description: "Neueva Zelanda (+64)",
      code: "64"
    },
    {
      description: "Nicaragua (+505)",
      code: "505"
    },
    {
      description: "Niger (+227)",
      code: "227"
    },
    {
      description: "Nigeria (+234)",
      code: "234"
    },
    {
      description: "Niue (+683)",
      code: "683"
    },
    {
      description: "Corea del Norte (+850)",
      code: "850"
    },
    {
      description: "Islas Marianas del Norte (+1-670)",
      code: "1-670"
    },
    {
      description: "Noruega (+47)",
      code: "47"
    },
    {
      description: "Omán (+968)",
      code: "968"
    },
    {
      description: "Pakistán (+92)",
      code: "92"
    },
    {
      description: "Palau (+680)",
      code: "680"
    },
    {
      description: "Palestina (+970)",
      code: "970"
    },
    {
      description: "Panamá (+507)",
      code: "507"
    },
    {
      description: "Papua Nueva Guinea (+675)",
      code: "675"
    },
    {
      description: "Paraguay (+595)",
      code: "595"
    },
    {
      description: "Perú (+51)",
      code: "51"
    },
    {
      description: "Filipinas (+63)",
      code: "63"
    },
    {
      description: "Pitcairn (+64)",
      code: "64"
    },
    {
      description: "Polonia (+48)",
      code: "48"
    },
    {
      description: "Portugal (+351)",
      code: "351"
    },
    {
      description: "Puerto Rico (+1-787, 1-939)",
      code: "1-787, 1-939"
    },
    {
      description: "Katar (+974)",
      code: "974"
    },
    {
      description: "República del Congo (+242)",
      code: "242"
    },
    {
      description: "Reunión (+262)",
      code: "262"
    },
    {
      description: "Rumanía (+40)",
      code: "40"
    },
    {
      description: "Rusia (+7)",
      code: "7"
    },
    {
      description: "Ruanda (+250)",
      code: "250"
    },
    {
      description: "San Bartolomé (+590)",
      code: "590"
    },
    {
      description: "Santa Helena (+290)",
      code: "290"
    },
    {
      description: "San Cristóbal y Nieves (+1-869)",
      code: "1-869"
    },
    {
      description: "Santa Lucía (+1-758)",
      code: "1-758"
    },
    {
      description: "San Martín (+590)",
      code: "590"
    },
    {
      description: "San Pedro y Miquelón (+508)",
      code: "508"
    },
    {
      description: "San Vicente y las Granadinas (+1-784)",
      code: "1-784"
    },
    {
      description: "Samoa (+685)",
      code: "685"
    },
    {
      description: "San Marino (+378)",
      code: "378"
    },
    {
      description: "Sao Tomé y Principe (+239)",
      code: "239"
    },
    {
      description: "Arabia Saudita (+966)",
      code: "966"
    },
    {
      description: "Senegal (+221)",
      code: "221"
    },
    {
      description: "Serbia (+381)",
      code: "381"
    },
    {
      description: "Seychelles (+248)",
      code: "248"
    },
    {
      description: "Sierra Leona (+232)",
      code: "232"
    },
    {
      description: "Singapur (+65)",
      code: "65"
    },
    {
      description: "Sint Maarten (+1-721)",
      code: "1-721"
    },
    {
      description: "Eslovaquia (+421)",
      code: "421"
    },
    {
      description: "Eslovenia (+386)",
      code: "386"
    },
    {
      description: "Islas Salomón (+677)",
      code: "677"
    },
    {
      description: "Somalia (+252)",
      code: "252"
    },
    {
      description: "Sudáfrica (+27)",
      code: "27"
    },
    {
      description: "Corea del Sur (+82)",
      code: "82"
    },
    {
      description: "Sudán del Sur (+211)",
      code: "211"
    },
    {
      description: "España (+34)",
      code: "34"
    },
    {
      description: "Sri Lanka (+94)",
      code: "94"
    },
    {
      description: "Sudán   (+249)",
      code: "249"
    },
    {
      description: "Surinam (+597)",
      code: "597"
    },
    {
      description: "Svalbard y Jan Mayen (+47)",
      code: "47"
    },
    {
      description: "Swaziland (+268)",
      code: "268"
    },
    {
      description: "Suecia (+46)",
      code: "46"
    },
    {
      description: "Suiza (+41)",
      code: "41"
    },
    {
      description: "Siria (+963)",
      code: "963"
    },
    {
      description: "Taiwán (+886)",
      code: "886"
    },
    {
      description: "Tayikistán (+992)",
      code: "992"
    },
    {
      description: "Tanzania (+255)",
      code: "255"
    },
    {
      description: "Tailandia (+66)",
      code: "66"
    },
    {
      description: "Togo (+228)",
      code: "228"
    },
    {
      description: "Tokelau (+690)",
      code: "690"
    },
    {
      description: "Tonga (+676)",
      code: "676"
    },
    {
      description: "Trinidad y Tobago (+1-868)",
      code: "1-868"
    },
    {
      description: "Túnez (+216)",
      code: "216"
    },
    {
      description: "Turquía (+90)",
      code: "90"
    },
    {
      description: "Turkmenistán (+993)",
      code: "993"
    },
    {
      description: "Islas Turcas y Caicos (+1-649)",
      code: "1-649"
    },
    {
      description: "Tuvalu (+688)",
      code: "688"
    },
    {
      description: "Islas Vírgenes de EE.UU (+1-340)",
      code: "1-340"
    },
    {
      description: "Uganda (+256)",
      code: "256"
    },
    {
      description: "Ucrania (+380)",
      code: "380"
    },
    {
      description: "Emiratos Árabes Unidos (+971)",
      code: "971"
    },
    {
      description: "Reino Unido (+44)",
      code: "44"
    },
    {
      description: "Estados Unidos (+1)",
      code: "1"
    },
    {
      description: "Uruguay (+598)",
      code: "598"
    },
    {
      description: "Uzbekistán (+998)",
      code: "998"
    },
    {
      description: "Vanuatu (+678)",
      code: "678"
    },
    {
      description: "Vaticano (+379)",
      code: "379"
    },
    {
      description: "Venezuela (+58)",
      code: "58"
    },
    {
      description: "Vietnam (+84)",
      code: "84"
    },
    {
      description: "Wallis y Futuna (+681)",
      code: "681"
    },
    {
      description: "Sahara Occidental (+212)",
      code: "212"
    },
    {
      description: "Yemen (+967)",
      code: "967"
    },
    {
      description: "Zambia (+260)",
      code: "260"
    },
    {
      description: "Zimbabue (+263)",
      code: "263"
    }
  ];